import { Injectable, signal } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { LocalStorageService } from '@core/services/local-storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class ClientNameService {
  constructor(
    private router: Router,
    private localStorageService: LocalStorageService
  ) {}
  clientName = signal<string | null>(null);
  private cachedClientName!: string;

  setCachedClientName(name: string): void {
    this.cachedClientName = name;
    this.localStorageService.set('clientName', this.cachedClientName);
    this.clientName.set(this.cachedClientName);
  }

  getCachedClientName(): string | null {
    return this.localStorageService.get('clientName') ?? this.clientName();
  }

  checkAndRedirect(url: string): boolean | UrlTree {
    const regex = /^\/(undefined|null|clientName)(\/.*)?$/;
    if (regex.test(url)) {
      const newUrl = url.replace(regex, `/${this.clientName()}$2`);

      return this.router.parseUrl(newUrl);
    }
    return true; // allow navigation
  }
}
